import { Box } from "@mui/material";
import React, { useState, ReactNode } from "react";

interface TabSwitcherProps {
  HistorialComponent: ReactNode;
  ComentariosComponent: ReactNode;
}

export const TabSwitcher: React.FC<TabSwitcherProps> = ({
  HistorialComponent,
  ComentariosComponent,
}) => {
  const [activeTab, setActiveTab] = useState<"historial" | "comentarios">(
    "historial"
  );

  return (
    <Box>
      {/* Encabezado de Tabs */}
      <Box style={{ display: "flex", borderBottom: "1px solid #D6D6D6" }}>
        <button
          onClick={() => setActiveTab("historial")}
          style={{
            flex: 1,
            border: "none",
            background: "none",
            borderBottom: activeTab === "historial"
              ? "1px solid purple"
              : "1px solid #D9D9D9",
            color: activeTab === "historial" ? "purple" : "#D6D6D6",
            cursor: "pointer",
            padding: "10px",
          }}
        >
          Historial
        </button>
        <button
          onClick={() => setActiveTab("comentarios")}
          style={{
            flex: 1,
            border: "none",
            background: "none",
            borderBottom: activeTab === "comentarios"
              ? "1px solid purple"
              : "1px solid #D9D9D9",
            color: activeTab === "comentarios" ? "purple" : "#D6D6D6",
            cursor: "pointer",
            padding: "10px",
          }}
        >
          Comentarios
        </button>
      </Box>

      {/* Renderizado Condicional */}
      <div style={{ padding: "20px", maxHeight:'300px', overflow: 'auto', scrollbarWidth: "none", msOverflowStyle: "none" }}>
        {activeTab === "historial" ? HistorialComponent : ComentariosComponent}
      </div>
    </Box>
  );
};
